import React, { Fragment } from 'react';
import salud from "../../images/ImagesSA/BannerFooter/salud.png";
import LocationHistory from '../LocationComponent/LocationHistory'
import ButtonImage from '../Buttons/ButtonImage';
import close from '../../images/ImagesSA/ButtonIcon/close.png';
import { logout } from '../User/Auth';


const styles = require('./Header_SA.module.scss');

const Header: React.FC = () => {
    let display: string = "none";
    let currentPath = LocationHistory;
    if (currentPath === "/medicalAppointment") {
        display = "block";
    }
    const logouts = () => {
        logout();
    }
    return (
        <Fragment>
            <div className= "row mt-2 mb-2">
                <div className="col-sm-12 col-lg-9 col-md-12 col-xs-12">
                    <a href="https://www.Saludsa.com" target="_blank" rel="noopener noreferrer">
                        <img src={salud} className="img-fluid" alt="Imagen más" />
                    </a>
                </div>
                <div style={{ display: display }} className= {styles.align + " col-sm-12 col-lg-3 col-md-12 col-xs-12"}>
                    <ButtonImage
                        id="btnClose"
                        onClick={logouts}
                        styleClass ="largetext"
                        textoButton="Cerrar Sesión"
                        minWidth="14rem"
                        maxWidth="14rem"
                        align=""
                        icon={<img src={close} className="img-fluid" alt="Cerrar Sesión"/>}
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default Header;

